import { Pool } from "../../model/pool";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = Pool;

export type TransformedDataType = DtoType;

type fetchResponseType = {
  data?: DtoType;
  error?: string;
};

export type GuiResponseType = {
  data?: DtoType;
  error?: string;
};

export async function getPoolsId({
  poolId,
}: {
  poolId: string;
}): Promise<GuiResponseType> {
  try {
    const url = apiUrls.getPoolsId.replace("{{id}}", poolId);
    const response: fetchResponseType = await fetchGetJSON(url);
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      return { data: response.data };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error getPoolsId:", err);
    return { error: (err as Error).message };
  }
}
